<template>
  <div class="filters-button" :class="{ visible }">
    <div class="filters-button-text body-l-regular">Фильтры</div>
    <div class="prefix">
      <div v-if="count" class="count">{{ count ? count : '' }}</div>
    </div>
  </div>
</template>

<script lang="ts">
export default defineComponent({
  name: 'FiltersButton',
  props: {
    count: {
      type: Number,
      default: 0,
    },
    visible: {
      type: Boolean,
      required: true,
    },
  },
});
</script>

<style scoped lang="scss">
.filters-button {
  display: flex;
  cursor: pointer;
  flex-flow: row nowrap;
  justify-content: center;
  align-items: center;
  color: $achromatic-black;
  transition: color 0.1s;
  font-size: 12px;
  line-height: 16px;
  min-width: 40px;
  height: 40px;
  margin-right: -12px;
  @include md-block {
    margin-right: 0;
  }
  @include xl-block {
    font-size: 16px;
    line-height: 24px;
  }

  .prefix {
    position: relative;
    background: url('/static/images/icon/filter-mobile.svg') center / contain
      no-repeat;
    display: flex;
    align-items: center;
    justify-content: center;
    height: 24px;
    min-width: 24px;

    .count {
      position: absolute;
      z-index: 2;
      right: -4px;
      top: -4px;
      padding: 2px 2px 0;
      display: flex;
      min-width: 16px;
      justify-content: center;
      align-items: center;
      border-radius: 20px;
      color: $white;
      border: 2px solid $white;
      background-color: $red1;
      font-size: 9px;
      font-style: normal;
      font-weight: 600;
      line-height: 10px; /* 111.111% */
      letter-spacing: 0.18px;
    }
  }

  .filters-button-text {
    display: none;
    @include md-block {
      display: block;
      margin-right: 4px;
      color: $achromatic-black;
    }
  }
}
</style>
